import { gql } from '@apollo/client';

export const MyEstateApplicationsSchema = gql`
  query MyEstateApplications($page: Float!) {
    myEstateApplications(page: $page) {
      id
      tenantUserId
      source
      estate {
        id
      }
      stage {
        kind
        expiredAt
        coTenants
        tenantCreditStudy
        bondPayment
        rejectionReason
        requirement {
          name
          bondPaymentPercentage
        }
      }
    }
  }
`;
